import { render, staticRenderFns } from "./callSetting.vue?vue&type=template&id=70ba4c88"
import script from "./callSetting.vue?vue&type=script&lang=js"
export * from "./callSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports